import { TUser } from '../api/security/User';

/**
 * Listings return an owner either as a bare id or as an expanded user.
 */
export function getOwnerId(owner?: number | TUser | null): number | undefined {
	if (owner === undefined || owner === null) {
		return undefined;
	}

	return typeof owner === 'number' ? owner : owner.id;
}

/**
 * Role permissions say a user may act on entities in general, never on this one.
 * Fails closed when the owner or the current user is unknown.
 */
export function isEntityOwner(ownerId?: number, userId?: number): boolean {
	return ownerId !== undefined && userId !== undefined && ownerId === userId;
}
